import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { route as routePropType } from 'common/propTypes';
import NotFound from 'common/components/NotFound';
import Layout from 'common/containers/Layout';

import RewardsPage from './Rewards';

const NotFoundPage = () => (
  <Layout heading="Rewards">
    <NotFound />
  </Layout>
);

const Routes = ({ match }) => (
  <Switch>
    <Route exact path={match.path} component={RewardsPage} />
    <Route component={NotFoundPage} />
  </Switch>
);

Routes.propTypes = routePropType;

export default Routes;
